import { render, staticRenderFns } from "./team-list-edit.vue?vue&type=template&id=716dfb84&scoped=true&"
import script from "./team-list-edit.vue?vue&type=script&lang=js&"
export * from "./team-list-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716dfb84",
  null
  
)

export default component.exports